module.exports = __webpack_public_path__ + "img/img-identity-1.6204789a.svg";